<template>
	<div>
		<v-badge :color="color" :content="content" inline>
		</v-badge>
	</div>
</template>

<script>

	export default {
		name: 'ReliabilityBadge',
		props: {
			member: { type: Object, default: null }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {

			}
		},
		computed: {
			color() {
				return this.member?.reliability?.color || '#bbb'
			},
			content() {
				return this.member?.reliability?.title || 'نامشخص'
			}
		},
		mounted() {
		},
		methods: {

		}
	}
</script>
<style scoped></style>
